module.exports = __webpack_public_path__ + "static/mfg-contact_us-min.76876947.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/contact-us/mfg-contact_us-min.png
// module id = 96
// module chunks = 28338073508207 43369700788870